const data = {
  pageName: "Eve",
  authUrl: "https://int-api.techsee.me/",
  sessionUrl: "https://vfgreve.techsee.ai/evevfgr?ott={ott}&mode={mode}",
  authShouldCreateOtt: true,
  eveMode: "troubleshooting",
  redirectUrl: "https://www.vodafone.gr/ypostirixi/syndesi-rythmiseis-router/",

  services: {
    translations: {
      url: "Eve/translations",
      params: {}
    },
    auth: {
      url: "Eve/auth",
      params: {}
    }
  }
};

exports.data = data;
